export const RETIREMENT_ACCOUNT_SUFFIX = '_Retirement';
